import ApiService from '@/services/ApiService';
export default {
  getProfile(id){
    return ApiService().get(`/users/${id}`);
  },
};
